import {
  Tabs,
} from 'antd';
import LocalTickets from './components/LocalTickets';
import CoreTickets from './components/CoreTickets';
import useTranslation from '../../../hooks/translation/useTranslation';

function Tickets() {
  const { trans } = useTranslation();
  return (
    <Tabs
      items={[{
        key: 'local-tickets',
        label: trans('tickets'),
        children: <LocalTickets />,
      }, {
        key: 'core-tickets',
        label: `${trans('core')} ${trans('tickets')}`,
        children: <CoreTickets />,
      }]}
    />
  );
}

export default Tickets;
